// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum PlayerGameStatus {
  Active = 1,
  Forfeited = 20,
  Resigned = 21,
  Lost = 22,
  Won = 40,
  Draw = 41
}
